(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rele-brand-system"] && !Shopify.designMode) return;
  try {
    (() => {
  const media = window.matchMedia('(prefers-reduced-motion: reduce)');
  let paused = false;
  let observer;
  try { paused = localStorage.getItem('rele-motion-paused') === 'true'; } catch {}
  const refresh = () => {
    const active = !paused && !media.matches && !document.hidden;
    document.documentElement.classList.toggle('rele-motion-active', active);
    document.documentElement.classList.toggle('rele-motion-off', paused || media.matches);
    document.querySelectorAll('[data-rele-motion-toggle]').forEach(button => {
      button.hidden = media.matches;
      button.setAttribute('aria-pressed', String(paused));
      button.textContent = paused ? button.dataset.labelResume : button.dataset.labelPause;
    });
  };
  const init = () => {
    document.querySelectorAll('[data-rele-motion-toggle]').forEach(button => {
      if (button.dataset.releBound) return;
      button.dataset.releBound = 'true';
      button.addEventListener('click', () => {
        paused = !paused;
        try { localStorage.setItem('rele-motion-paused', String(paused)); } catch {}
        refresh();
      });
    });
    observer?.disconnect();
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => entries.forEach(entry => entry.target.classList.toggle('is-visible', entry.isIntersecting)), { threshold: 0.05 });
      document.querySelectorAll('.rele-home__showcase').forEach(element => observer.observe(element));
    }
    const contact = document.querySelector('#contatti');
    if (contact && (location.hash === '#contatti' || contact.querySelector('[role="alert"], [role="status"]'))) contact.open = true;
    refresh();
  };
  document.addEventListener('visibilitychange', refresh);
  media.addEventListener('change', refresh);
  window.addEventListener('hashchange', () => {
    const contact = document.querySelector('#contatti');
    if (location.hash === '#contatti' && contact) contact.open = true;
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href$="#contatti"]');
    const contact = document.querySelector('#contatti');
    if (link && contact) contact.open = true;
  });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once:true });
  else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vele-product-notes"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{const link=event.target.closest('[data-vele-question]');if(!link)return;const box=document.querySelector('#contatti');const field=box?.querySelector('textarea[name="contact[body]"]');if(!field)return;box.open=true;if(!field.value.trim())field.value=[link.dataset.veleQuestion,link.dataset.veleSku,link.dataset.veleSize].filter(Boolean).join(' · ')+'\n';field.focus()});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vele-shipping-estimator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vele-shipping-estimator')) {
  class VeleShippingEstimator extends HTMLElement {
    static observedAttributes = ['data-market-countries'];

    static amount(value) {
      if (typeof value !== 'string' || !/^\d+(?:\.\d{1,2})?$/.test(value)) throw new Error('INVALID_RATE');
      const [whole, fraction = ''] = value.split('.');
      const amount = Number(whole) * 100 + Number(fraction.padEnd(2, '0'));
      if (!Number.isSafeInteger(amount)) throw new Error('INVALID_RATE');
      return amount;
    }

    static address(value) {
      const country = String(value.country ?? '').trim();
      const zip = String(value.zip ?? '').trim();
      const province = String(value.province ?? '').trim();
      if (!country || country.length > 100 || province.length > 100 || zip.length > 20 || /[\u0000-\u001f]/.test(country + zip + province)) throw new Error('ADDRESS');
      if (/^(Italy|Italia|IT)$/i.test(country) && !/^\d{5}$/.test(zip)) throw new Error('ADDRESS');
      const params = new URLSearchParams();
      params.set('shipping_address[country]', country);
      params.set('shipping_address[zip]', zip);
      if (province) params.set('shipping_address[province]', province);
      return params.toString();
    }

    static cartFingerprint(cart, requireWeights = true) {
      if (typeof requireWeights !== 'boolean') throw new Error('CONFIG');
      if (!cart || !Array.isArray(cart.items) || !Number.isSafeInteger(cart.total_price) || cart.total_price < 0 || !/^[A-Z]{3}$/.test(cart.currency ?? '')) throw new Error('CART');
      if (!cart.items.length || cart.item_count === 0) throw new Error('EMPTY_CART');
      if (cart.requires_shipping === false) throw new Error('NO_SHIPPING');
      for (const item of cart.items) {
        if (!item.key || !Number.isSafeInteger(item.quantity) || item.quantity < 1 || !Number.isSafeInteger(item.final_line_price) || item.final_line_price < 0 || typeof item.requires_shipping !== 'boolean') throw new Error('CART');
        if (item.requires_shipping && (!Number.isFinite(item.grams) || item.grams < 0 || requireWeights && item.grams === 0)) throw new Error('WEIGHT');
      }
      return JSON.stringify([cart.currency, cart.total_price, cart.total_weight, cart.items.map(item => [item.key, item.quantity, item.final_line_price, item.grams, item.requires_shipping])]);
    }

    static normalizeRates(payload, currency) {
      if (!payload || !Array.isArray(payload.shipping_rates)) throw new Error('INVALID_RATE');
      return payload.shipping_rates.map(rate => {
        if (!rate || typeof rate !== 'object') throw new Error('INVALID_RATE');
        const name = rate.presentment_name || rate.name;
        if (typeof name !== 'string' || !name.trim() || (rate.currency && rate.currency !== currency)) throw new Error('INVALID_RATE');
        const days = Array.isArray(rate.delivery_days) && rate.delivery_days.length > 0 && rate.delivery_days.every(day => Number.isSafeInteger(day) && day >= 0 && day <= 365) ? [...rate.delivery_days].sort((a,b) => a-b) : [];
        const validDate = date => typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date) && Number.isFinite(Date.parse(date + 'T00:00:00Z')) && new Date(date + 'T00:00:00Z').toISOString().slice(0,10) === date;
        let dates = [];
        if (Array.isArray(rate.delivery_range) && rate.delivery_range.length === 2 && rate.delivery_range.every(validDate) && rate.delivery_range[0] <= rate.delivery_range[1]) dates = [...rate.delivery_range];
        else if (validDate(rate.delivery_date)) dates = [rate.delivery_date];
        return {name:name.trim(), price:this.amount(rate.price), days, dates};
      });
    }

    static async calculate({root, address, fetcher, signal, requireWeights = true, wait = ms => new Promise(resolve => setTimeout(resolve, ms)), attempts = 8}) {
      if (typeof root !== 'string' || !/^\/(?!\/)[^?#\\\s]*$/.test(root)) throw new Error('ROOT');
      root = root.replace(/\/+$/, '') + '/';
      const params = this.address(address);
      const read = async (path, method = 'GET') => {
        signal?.throwIfAborted();
        const response = await fetcher(root + path, {method, signal, credentials:'same-origin', cache:'no-store', redirect:'error', headers:{Accept:'application/json'}});
        if (!response.ok) throw new Error(response.status === 422 ? 'ADDRESS' : 'NETWORK');
        return response.json();
      };
      const before = await read('cart.js');
      const fingerprint = this.cartFingerprint(before, requireWeights);
      await read('cart/prepare_shipping_rates.json?' + params, 'POST');
      for (let attempt = 0; attempt < attempts; attempt++) {
        signal?.throwIfAborted();
        const payload = await read('cart/async_shipping_rates.json?' + params);
        if (payload !== null) {
          const rates = this.normalizeRates(payload, before.currency);
          const after = await read('cart.js');
          if (this.cartFingerprint(after, requireWeights) !== fingerprint) throw new Error('CART_CHANGED');
          signal?.throwIfAborted();
          return {rates, subtotal:after.total_price, currency:after.currency, fingerprint};
        }
        if (attempt + 1 < attempts) await wait(Math.min(500 * (attempt + 1), 2000));
      }
      throw new Error('TIMEOUT');
    }

    connectedCallback() {
      if (this.lifecycle) return;
      this.lifecycle = new AbortController();
      this.form = this.querySelector('form');
      this.country = this.form.elements.namedItem('country');
      this.province = this.form.elements.namedItem('province');
      this.zip = this.form.elements.namedItem('zip');
      this.button = this.form.querySelector('button');
      this.status = this.querySelector('[data-status]');
      this.results = this.querySelector('[data-results]');
      this.list = this.querySelector('[data-rate-list]');
      this.summary = this.querySelector('[data-summary]');
      const options = {signal:this.lifecycle.signal};
      this.form.addEventListener('submit', event => {event.preventDefault(); this.submit();}, options);
      this.country.addEventListener('change', () => this.updateProvinces(), options);
      this.form.addEventListener('input', () => this.invalidate(), options);
      this.form.addEventListener('change', () => this.invalidate(), options);
      this.results.addEventListener('change', event => {
        const index = Number(event.target.value);
        if (this.quote && Number.isInteger(index) && this.quote.rates[index]) this.selectRate(index);
      }, options);
      document.addEventListener('change', event => {
        if (!this.contains(event.target) && event.target.matches?.('[name^="updates"], [name="quantity"]')) this.invalidate(this.dataset.changed);
      }, options);
      for (const type of ['shopify:cart:lines-update', 'shopify:cart:discount-update']) {
        document.addEventListener(type, () => this.invalidate(this.dataset.changed), options);
      }
      window.addEventListener('pagehide', () => this.invalidate(), options);
      window.addEventListener('pageshow', () => this.invalidate(), options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.invalidate();
      }, options);
      this.updateMarketCountries();
    }

    attributeChangedCallback() {
      if (this.lifecycle) this.updateMarketCountries();
    }

    disconnectedCallback() {
      this.invalidate();
      this.lifecycle?.abort();
      this.lifecycle = null;
    }

    updateMarketCountries() {
      if (this.countryOptionsSource !== this.country) {
        this.countryOptionsSource = this.country;
        this.countryOptions = Array.from(this.country.options)
          .filter(option => option.value.trim() && !/^-+$/.test(option.value.trim()) && !/^-+$/.test(option.textContent.trim()))
          .map(option => option.cloneNode(true));
      }
      const selected = this.country.value;
      let names = [];
      let valid = false;
      try {
        const values = JSON.parse(this.dataset.marketCountries);
        valid = Array.isArray(values) && values.every(value => typeof value === 'string' && value.trim() && value.length <= 100 && !/^[\s-]+$|[\u0000-\u001f]/.test(value));
        if (valid) names = values.map(value => value.trim().normalize('NFC'));
      } catch {}
      const allowed = new Set(names);
      const options = this.countryOptions.filter(option => allowed.has(option.value.trim().normalize('NFC')) || allowed.has(option.textContent.trim().normalize('NFC')));
      this.country.replaceChildren(new Option(this.dataset.choose, ''), ...options.map(option => option.cloneNode(true)));
      this.country.value = options.some(option => option.value === selected) ? selected : options.length === 1 ? options[0].value : '';
      this.marketsAvailable = options.length > 0;
      this.marketAvailabilityMessage = valid ? this.dataset.noRates : this.dataset.error;
      this.country.disabled = !this.marketsAvailable;
      this.form.hidden = !this.marketsAvailable;
      this.updateProvinces();
      this.invalidate();
    }

    updateProvinces() {
      let provinces = [];
      try {
        const data = JSON.parse(this.country.selectedOptions[0]?.dataset.provinces || '[]');
        if (Array.isArray(data)) provinces = data.filter(row => Array.isArray(row) && row.length >= 2 && typeof row[0] === 'string' && typeof row[1] === 'string');
      } catch {}
      this.province.replaceChildren(new Option(this.dataset.choose, ''));
      for (const [value, label] of provinces) this.province.add(new Option(label, value));
      this.province.disabled = provinces.length === 0;
      this.province.required = provinces.length > 0;
      this.querySelector('[data-province-field]').hidden = provinces.length === 0;
      const italy = /^(Italy|Italia|IT)$/i.test(this.country.value);
      this.zip.required = italy;
      this.zip.inputMode = italy ? 'numeric' : 'text';
      if (italy) this.zip.setAttribute('pattern', '[0-9]{5}');
      else this.zip.removeAttribute('pattern');
    }

    invalidate(message = '') {
      this.sequence = (this.sequence || 0) + 1;
      this.pending?.abort();
      this.pending = null;
      clearTimeout(this.expiration);
      clearTimeout(this.requestTimeout);
      this.quote = null;
      if (!this.results) return;
      this.results.hidden = true;
      this.summary.hidden = true;
      this.list.replaceChildren();
      this.status.textContent = this.marketsAvailable === false ? this.marketAvailabilityMessage : message;
      this.button.disabled = this.marketsAvailable === false;
      this.form.removeAttribute('aria-busy');
    }

    async submit() {
      if (this.marketsAvailable !== true || !this.form.reportValidity() || this.pending) return;
      this.invalidate();
      const sequence = this.sequence;
      const pending = new AbortController();
      this.pending = pending;
      this.button.disabled = true;
      this.form.setAttribute('aria-busy', 'true');
      this.status.textContent = this.dataset.loading;
      this.requestTimeout = setTimeout(() => pending.abort(), 25000);
      try {
        const quote = await this.constructor.calculate({root:this.dataset.root, address:{country:this.country.value, province:this.province.disabled ? '' : this.province.value, zip:this.zip.value}, fetcher:window.fetch.bind(window), signal:pending.signal, requireWeights:this.dataset.requireWeights !== 'false'});
        if (sequence !== this.sequence || !this.isConnected) return;
        this.quote = quote;
        this.renderRates();
        this.expiration = setTimeout(() => this.invalidate(this.dataset.expired), 60000);
      } catch (error) {
        if (sequence !== this.sequence || !this.isConnected) return;
        const messages = {EMPTY_CART:this.dataset.empty, NO_SHIPPING:this.dataset.noShipping, WEIGHT:this.dataset.weight, CART_CHANGED:this.dataset.changed, ADDRESS:this.dataset.invalidAddress};
        this.status.textContent = messages[error.message] || this.dataset.error;
      } finally {
        if (sequence === this.sequence) {
          clearTimeout(this.requestTimeout);
          this.pending = null;
          this.button.disabled = false;
          this.form.removeAttribute('aria-busy');
        }
      }
    }

    money(amount) {
      return new Intl.NumberFormat(this.dataset.locale || 'it', {style:'currency', currency:this.quote.currency}).format(amount / 100);
    }

    deliveryText(rate) {
      const today = new Date().toISOString().slice(0,10);
      if (rate.dates.length && rate.dates.every(date => date >= today)) {
        const formatter = new Intl.DateTimeFormat(this.dataset.locale || 'it', {day:'numeric', month:'short', year:'numeric', timeZone:'UTC'});
        return this.dataset.datePrefix + ' ' + rate.dates.map(date => formatter.format(new Date(date + 'T00:00:00Z'))).join(' – ');
      }
      if (rate.days.length) return this.dataset.daysPrefix + ' ' + [...new Set([rate.days[0], rate.days.at(-1)])].join('–') + ' ' + this.dataset.daysSuffix;
      return this.dataset.unknownTime;
    }

    renderRates() {
      this.list.replaceChildren();
      if (!this.quote.rates.length) {this.status.textContent = this.dataset.noRates; return;}
      this.status.textContent = '';
      this.quote.rates.forEach((rate, index) => {
        const label = document.createElement('label');
        label.className = 'vele-estimator__rate';
        const radio = document.createElement('input');
        radio.type = 'radio'; radio.name = 'vele-rate-' + this.country.id; radio.value = String(index);
        const name = document.createElement('strong'); name.textContent = rate.name;
        const price = document.createElement('span'); price.textContent = this.money(rate.price);
        const time = document.createElement('small'); time.textContent = this.deliveryText(rate);
        label.append(radio, name, price, time);
        this.list.append(label);
      });
      this.results.hidden = false;
    }

    selectRate(index) {
      const rate = this.quote.rates[index];
      const total = this.quote.subtotal + rate.price;
      if (!Number.isSafeInteger(total)) {this.invalidate(this.dataset.error); return;}
      this.querySelector('[data-subtotal]').textContent = this.money(this.quote.subtotal);
      this.querySelector('[data-selected-price]').textContent = this.money(rate.price);
      this.querySelector('[data-total]').textContent = this.money(total);
      this.summary.hidden = false;
    }
  }
  customElements.define('vele-shipping-estimator', VeleShippingEstimator);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vele-wardrobe"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('vele-wardrobe')){
  class VeleWardrobe extends HTMLElement{
    static handle(value){return typeof value==='string'&&/^[a-z0-9][a-z0-9-]{0,199}$/.test(value)}
    static searchPath(value,origin){try{const u=new URL(value,origin);if(u.origin!==origin||!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:collections\/[a-z0-9-]+|search)\/?$/.test(u.pathname))return null;const params=new URLSearchParams();for(const [k,v]of u.searchParams){if((k==='q'||k==='sort_by'||k==='type'||/^filter\.[a-z0-9_.]+$/i.test(k))&&v.length<=160)params.append(k,v)}const out=u.pathname+(params.size?'?'+params:'');return out.length<=2000?out:null}catch{return null}}
    connectedCallback(){if(this.bound)return;this.bound=true;this.strings=JSON.parse(this.querySelector('[data-vele-strings]').textContent);this.dialog=this.querySelector('dialog');this.key='vele-wardrobe-v1:'+this.dataset.shop;this.selected=[];this.products=new Map();this.version=0;this.abort=null;this.restore();this.onClick=e=>this.click(e);document.addEventListener('click',this.onClick);this.onSection=()=>this.refresh();document.addEventListener('shopify:section:load',this.onSection);this.refresh();this.querySelector('[data-vele-close]').addEventListener('click',()=>this.dialog.close());this.dialog.addEventListener('close',()=>{this.version++;this.abort?.abort()})}
    disconnectedCallback(){document.removeEventListener('click',this.onClick);document.removeEventListener('shopify:section:load',this.onSection);this.abort?.abort();this.bound=false}
    restore(){let data;try{data=JSON.parse(localStorage.getItem(this.key))}catch{}this.handles=Array.isArray(data?.handles)?[...new Set(data.handles.filter(VeleWardrobe.handle))].slice(0,20):[];this.searches=Array.isArray(data?.searches)?data.searches.filter(s=>s&&typeof s.title==='string'&&s.title.length<=160&&VeleWardrobe.searchPath(s.path,location.origin)===s.path).slice(0,20):[]}
    persist(){try{localStorage.setItem(this.key,JSON.stringify({handles:this.handles,searches:this.searches}));return true}catch{this.storageFailed=true;this.status(this.strings.session_only);return false}}
    status(value){this.querySelector('[data-vele-status]').textContent=value}
    node(tag,text){const n=document.createElement(tag);if(text!==undefined)n.textContent=text;return n}
    clearContent(target){if(this.dialog.open&&target.contains(document.activeElement))this.querySelector('[data-vele-close]').focus({preventScroll:true});target.replaceChildren()}
    button(text,fn){const b=this.node('button',text);b.type='button';b.addEventListener('click',fn);return b}
    refresh(){document.querySelectorAll('[data-vele-save]').forEach(b=>{b.hidden=false;const saved=this.handles.includes(b.dataset.veleSave);b.textContent=saved?this.strings.saved:this.strings.save;b.setAttribute('aria-pressed',String(saved))});document.querySelectorAll('[data-vele-open],[data-vele-save-search]').forEach(b=>b.hidden=false)}
    click(event){const b=event.target.closest('[data-vele-save],[data-vele-open],[data-vele-save-search]');if(!b)return;event.preventDefault();if(b.hasAttribute('data-vele-open')){this.dialog.showModal();this.render();return}if(b.hasAttribute('data-vele-save-search')){const path=VeleWardrobe.searchPath(location.href,location.origin);if(!path)return;if(!this.searches.some(s=>s.path===path)){this.searches.unshift({path,title:(document.title+' · '+new URLSearchParams(location.search).toString()).slice(0,160)});this.searches=this.searches.slice(0,20)}this.dialog.showModal();this.renderSearches();this.querySelector('[data-vele-products]').replaceChildren();this.querySelector('[data-vele-comparison]').replaceChildren();this.status(this.persist()?this.strings.search_saved:this.strings.session_only);return}const handle=b.dataset.veleSave;if(!VeleWardrobe.handle(handle))return;if(this.handles.includes(handle))this.handles=this.handles.filter(h=>h!==handle);else if(this.handles.length<20)this.handles.push(handle);else{this.dialog.showModal();this.status(this.strings.limit);return}this.persist();this.refresh()}
    root(){try{const u=new URL(this.dataset.root,location.origin);return u.origin===location.origin&&u.pathname.startsWith('/')&&!u.search&&!u.hash?u.pathname.replace(/\/+$/, '')+'/':null}catch{return null}}
    async render(){this.abort?.abort();this.abort=new AbortController();const version=++this.version;const signal=this.abort.signal;const requestAbort=this.abort;const timeout=setTimeout(()=>requestAbort.abort(),12000);const root=this.root();if(!root){clearTimeout(timeout);this.status(this.strings.failed);return}this.renderSearches();this.status(this.handles.length?this.strings.loading:this.strings.empty);const container=this.querySelector('[data-vele-products]');this.clearContent(container);this.products.clear();const results=await Promise.all(this.handles.map(async handle=>{try{const response=await fetch(root+'products/'+encodeURIComponent(handle)+'.js',{signal,credentials:'same-origin',headers:{Accept:'application/json'}});if(!response.ok)throw Error();const p=await response.json();if(p.handle!==handle||typeof p.title!=='string'||!Array.isArray(p.variants))throw Error();return {handle,p}}catch{return {handle,p:null}}}));clearTimeout(timeout);if(version!==this.version)return;if(signal.aborted){this.status(this.strings.failed);return}this.status(this.storageFailed?this.strings.session_only:results.length?'':this.strings.empty);for(const {handle,p}of results){if(p)this.products.set(handle,p);const article=this.node('article');if(p){const source=typeof p.featured_image==='string'?p.featured_image:null;if(source){try{const u=new URL(source,location.origin);if(u.protocol==='https:'&&(u.hostname==='cdn.shopify.com'||u.origin===location.origin)){const image=this.node('img');image.src=u.href;image.alt=p.title;image.loading='lazy';image.width=400;image.height=500;article.append(image)}}catch{}}article.append(this.node('h3',p.title));const link=this.node('a',this.strings.view);link.href=root+'products/'+handle;article.append(link);const eligible=this.eligible(p);article.append(this.node('p',eligible.length?eligible.map(v=>v.public_title||v.title).join(' / '):this.strings.unavailable));if(eligible.length)article.append(this.node('p',this.price(Math.min(...eligible.map(v=>v.price)))));const label=this.node('label');const check=this.node('input');check.type='checkbox';check.checked=this.selected.includes(handle);label.append(check,document.createTextNode(this.strings.compare));check.addEventListener('change',()=>{if(check.checked&&!this.selected.includes(handle)){if(this.selected.length>=3){check.checked=false;this.status(this.strings.compare_limit);return}this.selected.push(handle)}else this.selected=this.selected.filter(h=>h!==handle);this.renderCompare()});article.append(label)}else article.append(this.node('p',handle+' — '+this.strings.failed));article.append(this.button(this.strings.remove,()=>{this.handles=this.handles.filter(h=>h!==handle);this.selected=this.selected.filter(h=>h!==handle);this.persist();this.refresh();this.render()}));container.append(article)}this.selected=this.selected.filter(h=>this.products.has(h));this.renderCompare()}
    eligible(p){const tags=Array.isArray(p.tags)?p.tags:[];if(!tags.includes('VC-DATI-VERIFICATI')||tags.some(t=>['VC-FOTO-DA-VERIFICARE','VC-VENDUTO','VENDUTO'].includes(t)))return [];return p.variants.filter(v=>v.available&&Number.isSafeInteger(v.price)&&v.price>0)}
    price(value){try{return new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:this.dataset.currency}).format(value/100)}catch{return String(value/100)+' '+this.dataset.currency}}
    renderSearches(){const target=this.querySelector('[data-vele-searches]');this.clearContent(target);if(!this.searches.length)target.append(this.node('p',this.strings.no_searches));for(const s of this.searches){const row=this.node('div');row.className='vele-search-row';const a=this.node('a',s.title);a.href=s.path;row.append(a,this.button(this.strings.remove,()=>{this.searches=this.searches.filter(x=>x.path!==s.path);this.persist();this.renderSearches()}));target.append(row)}}
    renderCompare(){const target=this.querySelector('[data-vele-comparison]');this.clearContent(target);if(!this.selected.length)return;const table=this.node('table'),body=this.node('tbody');const rows=[['',p=>p.title],[this.strings.sizes,p=>this.eligible(p).map(v=>v.public_title||v.title).join(' / ')||this.strings.unavailable],[this.strings.price,p=>{const v=this.eligible(p);return v.length?this.price(Math.min(...v.map(x=>x.price))):this.strings.unavailable}]];for(const [label,read]of rows){const tr=this.node('tr');const th=this.node('th',label);th.scope='row';tr.append(th);this.selected.forEach(h=>tr.append(this.node('td',read(this.products.get(h)))));body.append(tr)}table.append(body);target.append(table)}
  }
  customElements.define('vele-wardrobe',VeleWardrobe);
}
  } catch(e) { console.error(e); }
})();

})();
